import Button from 'components/partials/button/button';

import { MARK_PROMPTS_LABEL } from '../mark-panel.constants';
import type { MarkPrompt } from '../mark-panel.types';

export interface MarkPromptListProps {
  prompts: readonly MarkPrompt[];
  onSelect: (prompt: MarkPrompt) => void;
  isDisabled?: boolean;
}

const MarkPromptList = ({
  prompts,
  onSelect,
  isDisabled,
}: MarkPromptListProps) => {
  if (!prompts.length) return null;

  return (
    <div className="flex flex-col gap-1.5 pr-10">
      <span className="text-sm font-semibold text-gray-500">
        {MARK_PROMPTS_LABEL}
      </span>

      <div className="flex flex-col gap-2">
        {prompts.map((prompt) => (
          <Button
            key={prompt.id}
            variant="reserve-outlined"
            className="w-full rounded-md border-navy-100 px-3 py-2.5 text-left text-sm font-normal whitespace-normal text-gray-700"
            onClick={() => onSelect(prompt)}
            disabled={isDisabled}
          >
            {prompt.text}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default MarkPromptList;
